import styled from 'styled-components';

export const Badge = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  padding: 8px;
  border-radius: 100px;
  background: ${(props) => props.theme.$dark_green};
  color: ${(props) => props.theme.$white};
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
`;
